'use strict';

(function () {
  'use strict';

  angular.module('vnext').controller('AppFeedbackCtrl', AppFeedbackCtrl);

  AppFeedbackCtrl.$inject = ['appFeedbackSvc', '$translate', 'focus'];

  /* @ngInject */
  function AppFeedbackCtrl(appFeedbackSvc, $translate, focus) {
    var vm = this;
    vm.title = 'AppFeedbackCtrl';
    vm.feedbackTypes = ['TECHNICAL_ISSUE', 'CONTENT_ISSUE', 'LEGAL_ISSUE'];
    vm.feedback = {
      appFeedbackType: vm.feedbackTypes[0],
      message: ''
    };
    vm.isFeedbackSubmitted = false;
    vm.$onInit = activate;

    function activate() {
      focus.byId('feedback-title');
    }

    vm.getTranslation = function (key) {
      return $translate.instant('vnext.feedback.types.' + key);
    };

    vm.submit = function () {
      vm.isFeedbackSubmitted = true;
      appFeedbackSvc.save(vm.feedback);
      focus.byId('thanks-wrapper');
    };
  }
})();